interface SectionHeaderProps {
  title: string;
  right?: React.ReactNode;
}

export const SectionHeader = ({ title, right }: SectionHeaderProps) => {
  return (
    <div className="border-b border-slate-200 pb-6 mb-8 px-8 pt-8">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-light text-slate-800 tracking-tight">{title}</h2>
        {right}
      </div>
    </div>
  );
};
